import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const useEventListToolbarStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    marginBottom: tokens.spacingVerticalMNudge,
    flexWrap: 'wrap',
    [mq.tablet]: {
      gap: tokens.spacingHorizontalS,
    },
  },
  searchContainer: {
    flex: 1,
    maxWidth: '20rem',
    [mq.tablet]: {
      maxWidth: 'none',
      flex: '1 1 100%',
      order: -1,
    },
  },
  filterButton: {
    minWidth: 'auto',
  },
  resultCount: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    marginLeft: tokens.spacingHorizontalS,
    whiteSpace: 'nowrap',
  },
  spacer: {
    flex: 1,
  },
});
